import React, { lazy } from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { SocialProofSection } from './components/SocialProofSection';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { AuthorsSection } from './components/AuthorsSection';
import { ChaptersSection } from './components/ChaptersSection';
import { ProductSection } from './components/ProductSection';
import { FooterCTA } from './components/FooterCTA';
export function App() {
  return <div className="relative w-full min-h-screen bg-void text-white antialiased overflow-hidden" data-id="element-0">
      {/* Background Eye Image — GPU promoted, lazy loaded */}
      <div className="fixed inset-0 z-0 w-full h-full pointer-events-none" data-id="element-1">
        <img src="https://cdn.magicpatterns.com/uploads/4r9GwTdC2DbovVpB5eWkuB/Screenshot_2026-02-19_at_2.40.53_PM.png" alt="" role="presentation" loading="eager" decoding="async" className="absolute inset-0 w-full h-full object-cover object-center opacity-30 scale-110 gpu-layer" data-id="element-2" />
        {/* Gradient overlay to blend edges into void */}
        <div className="absolute inset-0 bg-void/40 mix-blend-multiply" data-id="element-3" />
      </div>

      {/* Content wrapper */}
      <div className="relative z-10" data-id="element-4">
        <Navbar data-id="element-5" />
        <HeroSection data-id="element-6" />
        <SocialProofSection data-id="element-7" />
        <ProblemSection data-id="element-8" />
        <SolutionSection data-id="element-9" />
        <AuthorsSection data-id="element-10" />
        <ChaptersSection data-id="element-11" />
        <ProductSection data-id="element-12" />
        <FooterCTA data-id="element-13" />
      </div>
    </div>;
}